import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const GetSubscriptionModel = types
  .model("GetSubscriptionModel", {
    sku: types.string,
    name: types.string,
    price: types.number,
    currency: types.string,
    active: types.boolean,
    tenure: types.string,
    productCode: types.string,
    description: types.string,
    isbns: types.array(types.string),
    vetIsbns: types.array(types.string),
  })
  .actions((self) => ({
    fetch(ID) {
      Framework.sendEvent("FETCHING_SUBSCRIPTION_DATA", {ID});
    },
    set(response) {
      const data = response.data.response;
      applySnapshot(self, {
        sku: data.sku,
        name: data.name,
        price: data.price,
        currency: data.currency,
        active: data.active,
        tenure: data.tenure,
        productCode: data.productCode,
        description: data.description,
        isbns: data.isbns,
        vetIsbns: data.vetIsbns,
      });
    },
  }));

export default GetSubscriptionModel;
